import "./App.scss";
import "./components/studio/styles.scss";
import Login from "./components/Login";
import SignUp from "./components/SignUp";
import UploadVideo from "./components/UploadVideo";
import VideoList from "./components/VideoList";
import VideoListPub from "./components/VideoListPub";
import VideoListStat from "./components/VideoListStat";
import VideoDetailStat from "./components/VideoDetailStat";
import VideoDetail from "./components/VideoDetail";
import EpisodeDetail from "./components/EpisodeDetail";
import DashBoard from "./components/DashBoard";
import VideoConfig from "./components/VideoConfig";
import UsersRegister from "./components/UsersRegister";
import SearchPage from "./components/SearchPage";
import SeriesWatch from "./components/SeriesWatch";
import StreamingHome from "./components/StreamingHome";
import CatalogPage from "./components/CatalogPage";
import Video from "./components/Video";
import LiveTVPage from "./components/LiveTVPage";
import LiveChannelStudio from "./components/LiveChannelStudio";
import UserLivePage from "./components/UserLivePage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./context/ProtectedRoute";
import PublicRoute from "./context/PublicRoute";
import AdminLayout from "./context/AdminLayout";
import Radius from "./components/Radius";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/signup"
            element={
              <PublicRoute>
                <SignUp />
              </PublicRoute>
            }
          />

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<StreamingHome />} />
            <Route path="/home" element={<StreamingHome />} />
            <Route
              path="/films"
              element={
                <CatalogPage
                  type="film"
                  pageTitle="Films"
                  pageDescription="Un catalogue cinema premium inspire de l'experience Netflix, avec reprise, recommandations et recherche intelligente."
                />
              }
            />
            <Route
              path="/series"
              element={
                <CatalogPage
                  type="serie"
                  pageTitle="Series"
                  pageDescription="Binge-watch, saisons, episodes et lecture continue dans une experience unifiee."
                />
              }
            />
            <Route
              path="/documentaires"
              element={
                <CatalogPage
                  type="documentaire"
                  pageTitle="Documentaires"
                  pageDescription="Films documentaires et docu-series regroupes dans un rayon dedie comme sur les grandes plateformes."
                />
              }
            />
            <Route path="/direct" element={<LiveTVPage />} />
            <Route path="/direct/create" element={<UserLivePage />} />
            <Route path="/direct/user/:roomId" element={<UserLivePage />} />
            <Route path="/live" element={<LiveTVPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/title/:id" element={<SeriesWatch />} />
            <Route path="/playlist/:id" element={<SeriesWatch />} />
            <Route path="/watch/series/:id" element={<SeriesWatch />} />
            <Route path="/watch/:id" element={<Video />} />
            <Route path="/watch/:id/episode/:episodeId" element={<Video />} />
            <Route path="/xxx/video/:id" element={<Video />} />

            <Route element={<AdminLayout />}>
              <Route path="/dashboard" element={<DashBoard />} />
              <Route path="/upload" element={<UploadVideo />} />
              <Route path="/video/config" element={<VideoConfig />} />
              <Route path="/live/studio" element={<LiveChannelStudio />} />
              <Route path="/videolist" element={<VideoList />} />
              <Route path="/videolist/pub" element={<VideoListPub />} />
              <Route path="/videolist/statistique" element={<VideoListStat />} />
              <Route path="/videoDetail/:id" element={<VideoDetail />} />
              <Route path="/episodeDetail/:id" element={<EpisodeDetail />} />
              <Route path="/video/:id" element={<Video />} />
              <Route path="/statistique/detail/:id" element={<VideoDetailStat />} />
              <Route path="/users/register" element={<UsersRegister />} />
              <Route path="radius" element={<Radius />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
